/* eslint-disable camelcase */
import { CONFIGS } from "../configs";
import { API } from "./API";
import { getApiDataUrl } from "../utils/platform";
import { NullOrEmpty } from "../utils"

export const getEITShopSoldStat = (query) => {
  var {
    shopName,
    type,
    sortBy,
    timeMin,
    timeMax
  } = query;

  query = `sort=${sortBy}`;

  if (!NullOrEmpty(shopName))
    query += `&shop_names=${shopName}`;

  if (!NullOrEmpty(type))
    query += `&type=${type}`;

  if (!NullOrEmpty(timeMin))
    query += `&timestamp>=${timeMin}`;

  if (!NullOrEmpty(timeMax))
    query += `&timestamp<=${timeMax}`;

  return API.get(`${getApiDataUrl()}/api/erank-stat/get?${query}`); //&t=${Math.floor(Math.random()*1000)}
};

export const getEITShopSoldStatGroup = (query) => {
  var {
    shopList,
    type,
    sortBy,
    timeMin,
    timeMax
  } = query;

  query = `sort=${sortBy}`;

  if (!NullOrEmpty(shopList))
    query += `&shop_list=${shopList}`;

  if (!NullOrEmpty(type))
    query += `&type=${type}`;

  if (!NullOrEmpty(timeMin))
    query += `&timestamp>=${timeMin}`;

  if (!NullOrEmpty(timeMax))
    query += `&timestamp<=${timeMax}`;

  return API.get(`${getApiDataUrl()}/api/erank-stat/get-group?${query}`); //&t=${Math.floor(Math.random()*1000)}
};

export const getEITShopSold = (query) => {
  var {
    shopName,
    type,
    timeMin,
    timeMax,
    sortBy,
    limit
  } = query;

  let sort = sortBy? sortBy: 'timestamp';

  query = `sort=${sort}`;

  if (!NullOrEmpty(shopName))
    query += `&shop_name=${shopName}`;

  if (!NullOrEmpty(limit))
    query += `&limit=${limit}`;

  if (!NullOrEmpty(timeMin))
    query += `&timestamp>=${timeMin}`;

  if (!NullOrEmpty(timeMax))
    query += `&timestamp<=${timeMax}`;

  // if (type != "")
  //   query += `&type=${type}`;

  // if (timeMin != "")
  //   query += `&timestamp>=${timeMin}`;

  // if (timeMin != "")
  //   query += `&timestamp<=${timeMax}`;

  return API.get(`${getApiDataUrl()}/api/erank/get?${query}`);
};

export const eitShopSoldService = {
  getEITShopSoldStat,
  getEITShopSoldStatGroup,
  getEITShopSold
};
